import { Extension, ExtensionPayload, Res } from '@/types'

import base from './base'

export const extensionsApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getAllExtensions: builder.query<Extension[], string>({
      query: (id) => `teachers/classroom-subjects/${id}/extension-projects`,
      transformResponse: (res: Res<Extension[]>) => res.data,
      providesTags: ['Extensions'],
    }),

    sendExtensions: builder.mutation<Extension, ExtensionPayload>({
      query: ({ classId, extensions }) => ({
        url: `teachers/classroom-subjects/${classId}/extension-projects`,
        method: 'POST',
        body: { extensions },
      }),
      invalidatesTags: ['Extensions'],
    }),
  }),
})

export const { useGetAllExtensionsQuery, useSendExtensionsMutation } = extensionsApi
